import { render, staticRenderFns } from "./formheadertype.vue?vue&type=template&id=66cd99d6&scoped=true"
import script from "./formheadertype.vue?vue&type=script&lang=js"
export * from "./formheadertype.vue?vue&type=script&lang=js"
import style0 from "./formheadertype.vue?vue&type=style&index=0&id=66cd99d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cd99d6",
  null
  
)

export default component.exports